import React, { useState } from 'react';
import OrphanAssignmentItem from '../../../../Domain/OrphanAssignmentItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';
import OrphanedMissingDateAssignmentSearchParams from './OrphanedMissingDateAssignmentSearchParams';

const AssignmentListOrphanCompletedDateAdmin: React.FC = () => {
  const [searchItem, setSearchItem] = useState(new OrphanedMissingDateAssignmentSearchParams());

  const startSearch = (searchItem: OrphanedMissingDateAssignmentSearchParams) => {
    setSearchItem(Object.assign(new OrphanedMissingDateAssignmentSearchParams(), searchItem));
  };

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={OrphanAssignmentItem}
        serviceFunction={OrphanedAssignmentService.GetAssignmentListOrphanCompletedDate}
        convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanAssignmentDBItems}
        searchItem={searchItem}
        searchParamsType={OrphanedMissingDateAssignmentSearchParams}
        showSearchStrip={true}
        clickOnStartSearch={startSearch}
        orderBy='CcCompanyName'
        errorCode='ALOCDA24'
      />
    </div>
  );
};

export default AssignmentListOrphanCompletedDateAdmin;
